import React, { createContext, useReducer, useEffect } from "react";
import reducer, { initialState } from "./reducer";
import Cookies from "universal-cookie";
import { cookieOptions } from "../utils/cookieConfig";
import {
    fetchDepartmentDropdownData,
    fetchOfficeDropdownData,
    fetchUserDropdownData,
    fetchLanguagesDropdownData,
    fetchCountriesDropdownData,
    fetchClientDropdownData,
    fetchCurrenciesDropdownData,
} from "../App/actions";
import { hasValidAuthSession } from "../utils/authSession";

const cookies = new Cookies();

//We will need to eventually combine them
const Store = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const tokenI = cookies.get("tokenImpersonator");

    if (window.__JWT_TOKEN__ && window.__USER_ID__ && window.__USER_ROLES__) {
        let user = {};
        user.roles = window.__USER_ROLES__;
        user.id = Number(window.__USER_ID__);
        user.office = Number(window.__USER_OFFICE__);
        user.department = window.__USER_DEPARTMENT_NAME__ || null;
        user.department_id = Number(window.__USER_DEPARTMENT__);
        user.title = window.__USER_TITLE__ || null;

        if (!tokenI) {
            cookies.set("tokenR", window.__JWT_TOKEN__, cookieOptions);
            cookies.set("userR", user, cookieOptions);
            cookies.set("userRId", Number(window.__USER_ID__), cookieOptions);
        }
    }

    useEffect(() => {
        // Only fetch dropdown data when the auth session is valid.
        if (hasValidAuthSession(cookies)) {
            fetchDepartmentDropdownData()(dispatch);
            fetchOfficeDropdownData()(dispatch);
            fetchUserDropdownData()(dispatch);
            fetchLanguagesDropdownData()(dispatch);
            fetchCountriesDropdownData()(dispatch);
            fetchClientDropdownData()(dispatch);
            fetchCurrenciesDropdownData()(dispatch);
        }
    }, []);

    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    );
};

export const Context = createContext(initialState);
export default Store;
